import { render, staticRenderFns } from "./SendingCategory.vue?vue&type=template&id=0246bc02"
import script from "./SendingCategory.vue?vue&type=script&lang=js"
export * from "./SendingCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports